// SignUp.js

import React, { useState, useEffect } from 'react'; // Add useEffect
import { Link } from 'react-router-dom';
import { validatePassword } from '../../utils/password-validation.js';
import './SignUp.css';
import '../../styles/PasswordRequirementsFormatting.css';
import api from '../../services/api'; // Import api instance


function SignUp() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [plan, setPlan] = useState('monthly');
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);


  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  // Add useEffect to check for plan query parameter
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const planParam = params.get('plan');
    if (planParam && (planParam === 'monthly' || planParam === 'quarterly')) {
      setPlan(planParam);
    }
  }, []);

  const handleSubscription = async () => {

    // Email validation
    if (!validateEmail(email)) {
      setError('Please enter a valid email address');
      return;
    }

    // Make sure passwords match
    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    // Password validation (check for complexity)
    const passwordError = validatePassword(password); //using utility function
    if (passwordError) {
      setError(passwordError);
      return;
    }


    setError('');
    setIsLoading(true);
    try {
      const response = await api.post('/api/signup', { email, password, planType: plan });
      const data = await response.data;

      if (data.error) {
        setError(data.error);
        return;
      }

      if (data.url) {
        window.location.href = data.url;
      } else {
        setError('Failed to create a Stripe session. Please try again.');
      }
    } catch (error) {
      if (error?.response?.status === 400) {
        setError(error?.response?.data?.error || 'Invalid input');
      } else {
        setError('Something went wrong');
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="signup-container">
      <h2>Sign Up</h2>
      {error && <p className="error-message">{error}</p>}
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleSubscription();
        }}
        className="signup-form"
      >
        <div className="input-group">
          <input
            type="email"
            placeholder="Email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="form-input"
          />
        </div>
        <div className="input-group password-group">
          <input
            type={showPassword ? 'text' : 'password'}
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="form-input"
          />
          <span
            className="toggle-password"
            onClick={() => setShowPassword(!showPassword)}
          >
            {showPassword ? (
              <i className="fas fa-eye" />
            ) : (
              <i className="fas fa-eye-slash" />
            )}
          </span>
        </div>
        <div className="input-group password-group">
          <input
            type={showConfirmPassword ? 'text' : 'password'}
            placeholder="Confirm Password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
            className="form-input"
          />
          <span
            className="toggle-password"
            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
          >
            {showConfirmPassword ? (
              <i className="fas fa-eye" />
            ) : (
              <i className="fas fa-eye-slash" />
            )}
          </span>
        </div>
        <div className="input-group">
          <select
            value={plan}
            onChange={(e) => setPlan(e.target.value)}
            className="plan-select"
          >
            <option value="monthly">Monthly Plan</option>
            <option value="quarterly">Quarterly Plan</option>
          </select>
        </div>
        <button type="submit" className="signup-button" disabled={isLoading}>
          {isLoading ? <div className="spinner"></div> : 'Sign Up & Subscribe'}
        </button>
      </form>

      <div className="login-prompt">
        Already have an account? <Link to="/login">Log in</Link>
      </div>

      <div className="password-requirements">
        <p>Password must contain:</p>
        <ul>
          <li>Between 8 and 16 characters</li>
          <li>Uppercase and lowercase letters</li>
          <li>At least one number</li>
          <li>At least one special character (!@#$%^&*)</li>
        </ul>
      </div>
    </div>
  );
}

export default SignUp;